/**
 * @file        src/lib/brandingSpecs.js
 * @description Single source of truth for admin-portal branding image rules,
 *              shared by the super-admin onboarding panel (Add Tenant → Admin
 *              Portal Branding) and the tenant's own Site Setting page so both
 *              enforce identical limits. Derived from where the assets render:
 *              the sidebar shows the logo at 50px tall (38px on the collapsed
 *              rail uses the favicon), and the favicon also becomes the browser
 *              tab + apple-touch icon, which require a square source.
 * @author      Kinetika Labs
 * @created     2026-08-04
 * @changelog
 *   - 2026-08-04 Claude — Initial.
 */

// Wide portal logo — login screen + expanded sidebar (rendered 50px tall).
// Roughly 3:1–5:1 landscape reads best; a tiny or huge source blurs or bloats.
export const LOGO_CHECK = { minW: 160, minH: 40, maxW: 2000, maxH: 500, maxBytes: 1024 * 1024 };
export const LOGO_HINT =
  'Recommended 400×100 px (about 4:1), transparent PNG or WebP. Accepted: 160×40 to 2000×500 px, max 1 MB.';

// Square mark — browser tab favicon, apple-touch icon, collapsed sidebar rail.
export const FAVICON_CHECK = { square: true, minW: 64, minH: 64, maxW: 512, maxH: 512, maxBytes: 512 * 1024 };
export const FAVICON_HINT =
  'Must be square. Recommended 256×256 px PNG. Accepted: 64×64 to 512×512 px, max 512 KB.';
